export const rm = (v) => (v == null ? "—" : v >= 1000 ? `R${(v / 1000).toFixed(2)}bn` : `R${Math.round(v).toLocaleString("en-ZA")}m`);
export const rand = (v) => (v == null ? "—" : `R${Math.round(v).toLocaleString("en-ZA")}`);
export const num = (v) => (v == null ? "—" : Number(v).toLocaleString("en-ZA"));
export const ml = (l) => `${(l / 1e6).toFixed(2)} ML`;
export const pct = (v) => (v == null ? "—" : `${v}%`);
export const ago = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

const TONES = {
  green: "bg-[#E8F0EC] text-[#1B4332] border-[#C2DACD]",
  gold: "bg-[#FAF1DC] text-[#8C6D1F] border-[#E9D9B0]",
  copper: "bg-[#FBECE7] text-[#A24A2F] border-[#F1CEC2]",
  stone: "bg-[#F4F1EA] text-[#57534E] border-[#E5E0D5]",
  teal: "bg-[#E0F2F1] text-[#0E7490] border-[#B6E0DE]",
  red: "bg-[#FDECEC] text-[#9B2C2C] border-[#F5C6C6]",
};
const STATUS_TONE = {
  Qualified: "green", Active: "green", Delivered: "green", Complete: "green", Approved: "green", "Approved for Payment": "green", Paid: "green", Awarded: "green", Operational: "green",
  "PO Issued": "green", Issued: "green", Distributed: "green", "Verified internal": "green", confirmed: "green", Construction: "green", "Financial Close": "green", Contracted: "green", Live: "green",
  Proposal: "gold", Contacted: "gold", "In Transit": "gold", "In Progress": "gold", Submitted: "gold", Shortlisted: "gold", "Pending Review": "gold", "Pending Approval": "gold", "In Review": "gold",
  Validating: "gold", Loading: "gold", "Source-reported": "gold", suggested: "gold", "Due Diligence": "gold", Structuring: "gold", Financing: "gold", "Renewal Due": "gold", Evaluated: "gold", "Bids Received": "gold",
  Exception: "copper", Lost: "red", Rejected: "red", Suspended: "red", "Documents Expired": "copper", Arrears: "copper", Unverified: "copper", unverified: "copper", "Pending Information": "copper",
  Outstanding: "copper", "Waiting Period": "teal", Received: "teal", Invited: "teal", Simulated: "copper", "Under Review": "gold",
};
export const toneOf = (s) => TONES[STATUS_TONE[s] || "stone"];
export const TONE = TONES;
